import axios from "axios";
import { getApiBaseUrl } from "../config/apiBase";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function login(username, password) {
  const response = await axios.post(
    `${getApiBaseUrl()}/api/auth/login`,
    { username, password },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  return unwrapApiResponse(response);
}
